/**
 * Section: Newsletter Modal
 * ------------------------------------------------------------------------------
 * Newsletter modal configuration for complete theme support
 * - https://github.com/Shopify/theme-scripts/tree/master/packages/theme-sections
 *
 * @namespace newsletterModal
 */

import log from 'salvo-lite/log'

import { register } from '@shopify/theme-sections'
import debounce from 'lodash-es/debounce'
import { on } from '../helpers/utils'
import breakpoints from '../helpers/breakpoints'

class ServiceCards {
    constructor () {
        this._selectors = {
            card: '[js-service-cards="card"]',
            cardBody: '[js-service-cards="cardBody"]',
            grid: '[js-service-cards="grid"]'
        }

        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit (theme, section) {
        register('service-cards', {

            /**
             * Initiates the section.
             */
            init () {
                this.setNodeSelectors()
                this.setResizeEvents()
                this.handleResizeEvent()
            },

            /**
             * Sets the node this.section._selectors.
             */
            setNodeSelectors () {
                this.carousel = theme.getComponentsById('service-cards-carousel')
                this.section = theme.getSectionsByType('service-cards')

                this.nodeSelectors = {
                    card: this.container.querySelectorAll(this.section._selectors.card)
                }
            },

            /**
             * Sets the resize events.
             */
            setResizeEvents () {
                on('resize', debounce(() => this.handleResizeEvent()), 250)
            },

            /**
             * Handles the resize event.
             */
            handleResizeEvent () {
                if (window.matchMedia(`(min-width: ${breakpoints.medium})`).matches) {
                    this.destroyCarousel()
                    this.resetCardHeights()
                    return
                }

                this.initiateCarousel()
                this.setCardHeights()
            },

            /**
             * Makes all card heights equal.
             * - Uses the tallest card as a baseline.
             */
            setCardHeights () {
                let tallest = 0
                const bodies = []
                const cardArray = [...this.nodeSelectors.card]

                cardArray.forEach((card) => {
                    const body = card.querySelector(this.section._selectors.cardBody)

                    bodies.push(body)

                    if (body.clientHeight >= tallest) {
                        tallest = body.clientHeight
                    }
                })

                bodies.forEach((body) => {
                    body.style.height = `${tallest}px`
                })
            },

            /**
             * Resets the card heights to auto.
             */
            resetCardHeights () {
                [...this.nodeSelectors.card].forEach((card) => {
                    card.querySelector(this.section._selectors.cardBody).style.height = 'auto'
                })
            },

            /**
             * Initiates the carousel instance.
             */
            initiateCarousel () {
                this.carousel.onInit()
            },

            /**
             * Destroys the carousel instance.
             * - Only if the carousel is constructed.
             */
            destroyCarousel () {
                if (!this.isCarouselActive()) {
                    return
                }

                this.carousel._destroy()
            },

            /**
             * Returns if the carousel is active.
             * @returns {Boolean}
             */
            isCarouselActive () {
                return this.carousel ? this.carousel._isActive() : false
            },

            /**
             * Callback function when section is loaded via 'sections.load()' or by the Theme Editor 'shopify:section:load' event.
             */
            onLoad () {
                this.init()
            }
        })
    }
}

export default ServiceCards



// WEBPACK FOOTER //
// ./src/resources/scripts/sections/ServiceCards.js